import API from "./API";

export default class AssetAPI extends API {
  constructor(parameters = {}) {
    super("/Asset", parameters);
  }

  createAsset(data) {
    return this.submit("post", `${this.endpoint}`, data);
  }

  updateAsset(data) {
    return this.submit("put", `${this.endpoint}`, data);
  }

  deleteAsset(assetName, underlyingAssetTypeName) {
    return this.submit('delete',
      `${this.endpoint}/assetName=${assetName}&underlyingAssetTypeName=${underlyingAssetTypeName}`)
  }

  async downloadAllAssets() {
    return await this.export("post", `${this.endpoint}/downloadAllAssets`);
  }
}
